const ENV = {
  production: {
    analyticsHost: 'https://static-assets.gowatchit.com',
    analyticsGWIHost: 'https://gowatchit.com',
    debug: false,
  },

  development: {
    analyticsHost: 'https://static-assets.gowatchit.com',
    analyticsGWIHost: 'http://localhost:3000',
    debug: true,
  },
};

export default ENV[process.env.NODE_ENV || 'development'];



// WEBPACK FOOTER //
// ./~/gwi-tracker/config/env.js